import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        projectId:'',
        projectName:'',
        provinceNavList:[],
        sceneType:'',
        sceneId:'',
        
        scheduleType:'',
        scheduleData:'',

        groupAddDev:false,
        
        groupAddDevList:[],
        groupAddDevStr:'',
        groupAddDevIndex:0,
        groupAddDevType:'',
        groupAddDevName:'',
        groupAddDevRemark:'',

        projectPageType:'',
        projectPageId:'',

        timezoneId: '',
        timezoneName:'',
        timezoneList:[],


        lampListUpdate:0,
        projectUpdate:0,

        userDetailsGetUpdate: 0,

        theme:'default',
        routerStr:'',
        remRatio:0,
        updateRemRatio:0,

        countryId:null,
        provinceId:null,
        cityId:null,
        hotelId:null,
        hotelType:'0',
        headerIdStr:null,
        headerUpdate:0,
        headerLogo:'',
        sideBarShow:false,
        userData:{
            version:'0',
            username:'',
            id:'',
            role:'',
            lastLoginTime:'2018-12-22 13:30:21',
            client_key:'',
            token:'',
            number:'',
            avatar:'',
        },
       
        editHotelLogoShow:false,
        editHotelLogoShowBg:false,
        longitude:0,
        latitude:0,

        domainName:'iotena',

        isGoogleapis:false,
        webapiAmap:false,

        scheduleTime : '',
        keywords: '',

        getUserSettingInfoDateValue: '',
        bjIndex:'',

        isMobile:false,

        themeType:'',
    },
    getters: {
        projectId:state=>state.projectId,
        projectName:state=>state.projectName,
        provinceNavList:state=>state.provinceNavList,
        sceneType:state=>state.sceneType,
        sceneId:state=>state.sceneId,

        scheduleType:state=>state.scheduleType,
        scheduleData:state=>state.scheduleData,
        
        groupAddDev:state=>state.groupAddDev,
        groupAddDevList:state=>state.groupAddDevList,
        groupAddDevStr: state=>state.groupAddDevStr,
        groupAddDevIndex: state=>state.groupAddDevIndex,
        groupAddDevType: state=>state.groupAddDevType,
        groupAddDevName: state=>state.groupAddDevName,
        groupAddDevRemark: state=>state.groupAddDevRemark,
        
        projectPageType:state=>state.projectPageType,
        projectPageId:state=>state.projectPageId,
        lampListUpdate:state=>state.lampListUpdate,
        userDetailsGetUpdate:state=>state.userDetailsGetUpdate,
        projectUpdate:state=>state.projectUpdate,
        
        timezoneId:state=>state.timezoneId,
        timezoneName:state=>state.timezoneName,
        // timezoneList:state=>state.timezoneList,

        scheduleTime :state=>state.scheduleTime,
        keywords :state=>state.keywords,
        
        theme:state=>state.theme,
        domainName:state=>state.domainName,
        routerStr:state=>state.routerStr,
        remRatio:state=>state.remRatio,

        headerLogo:state=>state.headerLogo,
        sideBarShow:state=>state.sideBarShow,

        editHotelLogoShow:state=>state.editHotelLogoShow,
        editHotelLogoShowBg:state=>state.editHotelLogoShowBg,

        countryId:state=>state.countryId,
        provinceId:state=>state.provinceId,
        cityId:state=>state.cityId,
        hotelId:state=>state.hotelId,
        hotelType:state=>state.hotelType,
        longitude:state=>state.longitude,
        latitude:state=>state.latitude,

        headerIdStr:state=>state.headerIdStr,
        headerUpdate:state=>state.headerUpdate,
        updateRemRatio:state=>state.updateRemRatio,

        version:state=>state.userData.version,
        username:state=>state.userData.username,
        id:state=>state.userData.id,
        role:state=>state.userData.role,
        lastLoginTime:state=>state.userData.lastLoginTime,
        client_key:state=>state.userData.client_key,
        token:state=>state.userData.token,
        number:state=>state.userData.number,
        avatar:state=>state.userData.avatar,
        

        isGoogleapis:state=>state.isGoogleapis,
        webapiAmap:state=>state.webapiAmap,

        getUserSettingInfoDateValue:state=>state.getUserSettingInfoDateValue,
        bjIndex :state=>state.bjIndex,

        isMobile :state=>state.isMobile,
        themeType:state=>state.themeType,
    },
    actions: {

    },
    mutations: {
        bjIndexSelectFun(state,payload){
            state.bjIndex = payload.bjIndex;
        },
        isMobileFun(state,payload){
            state.isMobile = payload.isMobile;
        },
        themeTypeFun(state,payload){
            state.themeType = payload.themeType;
        },
        getUserSettingInfoSelectFun(state,payload){
            state.getUserSettingInfoDateValue = payload.getUserSettingInfoDateValue;
        },
        projectSelectFun(state,payload){
            state.projectId = payload.projectId;
            state.projectName = payload.projectName;
        },
        provinceNavListSelectFun(state,payload){
            state.provinceNavList = payload.provinceNavList;
        },
        timezoneSelectFun(state,payload){
            state.timezoneId = payload.timezoneId;
            state.timezoneName = payload.timezoneName;
        },
        // timezoneNavListSelectFun(state,payload){
        //     state.timezoneList = payload.timezoneList;
        // },
        sceneTypeFun(state,payload){
            state.sceneId = payload.sceneId;
            state.sceneType = payload.sceneType;
        },
        scheduleTypeFun(state,payload){
            state.scheduleData = payload.scheduleData;
            state.scheduleType = payload.scheduleType;
        },
        
        groupAddDevFun(state,payload){
            if(payload.groupAddDev||payload.groupAddDev === false){
                state.groupAddDev = payload.groupAddDev;
            }
            if(payload.groupAddDevList){
                state.groupAddDevList = payload.groupAddDevList;
            }
            if(payload.groupAddDevStr||payload.groupAddDevStr === ''){
                state.groupAddDevStr = payload.groupAddDevStr;
            }
            if(payload.groupAddDevIndex){
                state.groupAddDevIndex = payload.groupAddDevIndex;
            }
            if(payload.groupAddDevType){
                state.groupAddDevType = payload.groupAddDevType;
            }
            if(payload.groupAddDevName){
                state.groupAddDevName = payload.groupAddDevName;
            }
            if(payload.groupAddDevRemark){
                state.groupAddDevRemark = payload.groupAddDevRemark;
            }
        },
        projectPageTypeFun(state,payload){
            state.projectPageType = payload.projectPageType;
            state.projectPageId = payload.projectPageId;
        },
        lampListUpdateFun(state,payload){
            state.lampListUpdate = payload.lampListUpdate;
        },
        userDetailsGetUpdateFun(state,payload){
            state.userDetailsGetUpdate = payload.userDetailsGetUpdate;
        },
        projectUpdateFun(state,payload){
            state.projectUpdate = payload.projectUpdate;
        },
        scheduleTimeFun(state,payload){
            state.scheduleTime = payload.scheduleTime;
        },
        keywordsFun(state,payload){
            state.keywords = payload.keywords;
        },
        THEME(state,payload){
            state.theme = payload.theme;
        },
        DOMAINNAME(state,payload){
            state.domainName = payload.domainName;
        },
        ISGOOGLEAPIS(state,payload){
            state.isGoogleapis = payload.isGoogleapis;
        },
        WEBAPIAMAP(state,payload){
            state.webapiAmap = payload.webapiAmap;
        },
        
        HEADERLOGO(state,payload){
            state.headerLogo = payload.headerLogo;
        },
        EDITHOTELLOGOSHOW(state,payload){
            if(payload.editHotelLogoShow){
                state.editHotelLogoShow = payload.editHotelLogoShow;
            }
            if(payload.editHotelLogoShowBg){
                state.editHotelLogoShowBg = payload.editHotelLogoShowBg;
            }
        },
        SIDEBARSHOW(state,payload){
            state.sideBarShow = payload.sideBarShow;
        },
        USERDATAFUN:(state,payload)=>{
            state.userData.version = payload.version;
            state.userData.username = payload.username;
            state.userData.id = payload.id;
            state.userData.role = payload.role;
            state.userData.lastLoginTime = payload.lastLoginTime;
            state.userData.client_key = payload.client_key;
            state.userData.token = payload.token;
            state.userData.number = payload.number;
            state.userData.avatar = payload.avatar;
        },
        avatarFun:(state,payload)=>{
            state.userData.avatar = payload.avatar;
        },
        VERSION:(state,payload)=>{
            state.userData.version = payload.version;
        },
        HEADERIDFUN:(state,payload)=>{
            if(payload.countryId||payload.countryId == ''){
                state.countryId = payload.countryId;    
            }
            if(payload.provinceId||payload.provinceId == ''){
                state.provinceId = payload.provinceId;    
            }
            if(payload.cityId||payload.cityId == ''){
                state.cityId = payload.cityId;    
            }
            if(payload.hotelId||payload.hotelId == ''){
                state.hotelId = payload.hotelId;    
            }
            if(payload.hotelType||payload.hotelType == ''){
                state.hotelType = payload.hotelType;    
            }
            if(payload.headerIdStr||payload.headerIdStr == ''){
                state.headerIdStr = payload.headerIdStr;    
            }
            if(payload.headerUpdate){
                state.headerUpdate = payload.headerUpdate;    
            }
        },

        LONLATFUN:(state,payload)=>{
            state.longitude = payload.longitude;    
            state.latitude = payload.latitude;    
        },
        UPDATEREMRATIOFUN:(state,payload)=>{
            state.updateRemRatio = payload.updateRemRatio;
        },

        ROUTERSTRFUN:(state,payload)=>{
            state.routerStr = payload.routerStr;
        },

        REMRATIOFUN:(state,payload)=>{
            state.remRatio = payload.remRatio;
        },
    },
})
